
export const hasVariations = (item) => {
  if (item?.type === 'bundles') {
    return item?.products?.some((bundleItem) => bundleItem.product_group?.has_variations) || false
  }

  return item?.has_variations || false
}

export const hasVariationSelected = (item) => item?.variation_id && item?.variation_id !== ''

export const isValidBundleVariations = (item) => {
  const bundleItemsWithVariations = item.products?.filter(
    (bundleItem) => bundleItem.product_group?.has_variations
  ) || []

  if (bundleItemsWithVariations.length === 0) return true

  if (!item.configuration) return false

  for (const bundleItem of bundleItemsWithVariations) {
    const bundleItemId = bundleItem.id
    const selectedVariationId = item.configuration[bundleItemId]

    if (!selectedVariationId || selectedVariationId === '') return false

    const variationExists = bundleItem.product_group.products.some(
      (variation) => variation.id === selectedVariationId
    )

    if (!variationExists) return false
  }

  return true
}

export const cleanConfiguration = (configuration) => {
  if (!configuration || typeof configuration !== 'object') return {}
  const cleaned = {}
  Object.entries(configuration).forEach(([key, value]) => {
    if (value && value !== '') {
      cleaned[key] = value
    }
  })

  return cleaned
}
